export class BlueUser {
    constructor() {
        this.status = 'LOADING';
    }
}
//# sourceMappingURL=blueUser.js.map